import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../../components/NextUITable'
import { usePost } from '../../../api/reactQueryCustomHooks'
import { apiRoute, GetLoginCredentialDb, linksUrl, URIEncrypt } from '../../../constants/enum'
import { faEdit, faPlus, faReceipt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalHeader, ModalContent, useDisclosure } from '@heroui/react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmBox from '../../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { calculateTotal } from '../../../Utility/utility'
import { resetImpExpDetailParams, setImpExpDetailParams, setImpExpNewEntryMode } from '../../../state/paymentEntrySlice'
import { enum_Report_Type } from '../../report/ReportUtility'
import ReportViewer from '../../report/ReportViewer'

const ImportExportEntryMaster = () => {
    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure()

    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { xtype } = useParams()
    const [itemToDelete, setItemToDelete] = useState("")
    const [selVouType, setSelVouType] = useState("")
    const [entryLabel, setEntryLabel] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "BookName", "PartyName", "Vou_No", "Remark", "Chq_Amt", "Chq_AmtD", "Chq_Date"]
    // const [data, setData] = useState([])
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
        dispatch(resetImpExpDetailParams())
    }, [])

    useEffect(() => {
        const params = [URIEncrypt.Payment, URIEncrypt.Receive]
        if (!params.includes(String(xtype)))
            navigate(linksUrl.dashboard)

        if (xtype && xtype != "") {

            let t_vouType = ""
            if (xtype == URIEncrypt.Receive) {
                t_vouType = 'R'
                setEntryLabel("Receive Againts Export")
            }
            if (xtype == URIEncrypt.Payment) {
                t_vouType = 'G'
                setEntryLabel("Payment Againts Import")
            }
            setSelVouType(t_vouType)
            funLoadData(t_vouType)
        }
    }, [xtype])

    const { isPending, isError,
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transactionEntry.fetch,
            queryKey: "Import Export Entry Data"
        })
    const exportColumns = [
        {
            name: "Book Name",
            uid: "BookName",
        },
        {
            name: "PartyName",
            uid: "Party Name",
        },
        {
            name: "Vou No",
            uid: "Vou_No",
        },
        {
            name: "Narration",
            uid: "Remark",
        },
        {
            name: "Amount",
            uid: "Chq_Amt",
        },
        {
            name: "Amount ($)",
            uid: "Chq_AmtD",
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            type: COLUMN_TYPE.date
        },




    ]
    const totalChqAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Chq_Amt",
            }),
        [data])

    const totalChqAmtD = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Chq_AmtD",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },
        {
            name: "Book Name",
            uid: "BookName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Party Name",
            uid: "PartyName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },


        {
            name: "Vou No",
            uid: "Vou_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Narration",
            uid: "Remark",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            isLineBreak: true
        },
        {
            name: "Amount",
            uid: "Chq_Amt",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalChqAmt,
            },
        },
        {
            name: "Amount ($)",
            uid: "Chq_AmtD",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalChqAmtD,
            },
        },
        {
            name: "Trans.Date",
            uid: "Chq_Date",
            align: COLUMN_ALIGN_TYPE.center,
            type: COLUMN_TYPE.date,
            sortable: true
        },

    ]
    
    const funLoadData = (vouType) => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                vou_type: vouType,
                trans_id: "",
                doc_for: vouType == "G" ? "IMPPAY" : "EXPREC",
                action: 'IMPEXP'

            }
        })
    }

    const reportModel = () => {
        return (
            <Modal
                isOpen={isOpenModel}
                onOpenChange={onOpenModelChange}
                size="md">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-row gap-1">
                                Voucher
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-col">
                                    <ReportViewer props_ReportType={selVouType == 'R' ? enum_Report_Type.RECVOUCHER
                                        : selVouType == 'G' ? enum_Report_Type.PAYVOUCHER : ""

                                    } />
                                </div>
                            </ModalBody>
                        </>

                    )}
                </ModalContent>
            </Modal>
        )
    }

    let downloadDataFooter = {
        BookName: "", PartyName: "", Vou_No: "", Chq_Amt: "Total:" + totalChqAmt,
        Chq_AmtD: "Total:" + totalChqAmtD,Chq_Date: " ",
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    compcode: row.CompCode,
                    transactionid: row.TransactionId,
                    pacid: row.Pac_Id,
                    voutype: row.Vou_Type,
                    gpbilltrnid: row.GpBillTrnId
                }

                dispatch(setImpExpDetailParams(obj))
                dispatch(setImpExpNewEntryMode(false))
                // }
                // else if (selVouType == 'G') {
                //     dispatch(setPayDetailParams(obj))
                //     dispatch(setPayNewEntryMode(false))
                // }

                navigate(funGetNaviLink())

            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, vou_type: row.Vou_Type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        // {
        //     icon: <FontAwesomeIcon color="#075985" icon={faReceipt} />,
        //     onClick: (row) => {
        //         //dispatch(resetr())


        //         // if (selVouType == 'R')
        //         //     dispatch(setImpExpDetailParams(row))
        //         // else if (selVouType == 'G')
        //         //     dispatch(setImpExpDetailParams(row))

        //         //onOpenModel()
        //     },
        //     type: ROW_ACTION_BTN_TYPE.link,
        // },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        funLoadData(selVouType);
        toast.success("Entry Deleted",
            { position: "top-center" })

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transactionEntry.deleteEntry,
        queryKey: "DeleteReceiveEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    transaction_id: itemToDelete.transaction_id,
                    vou_type: itemToDelete.vou_type
                }
            })
        }
    }
    const funGetNaviLink = () => {
        if (selVouType == 'R')
            return linksUrl.importExportEntry.rec + "/" + xtype + linksUrl.importExportEntry.createRecEntry;
        if (selVouType == "G")
            return linksUrl.importExportEntry.pay + "/" + xtype + linksUrl.importExportEntry.createPayEntry;
    }
    const handleAddNew = () => {
        dispatch(resetImpExpDetailParams())
        navigate(funGetNaviLink())
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName={`${entryLabel} Entries`} breadcrumbs={["Account", entryLabel + " Entry"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    downloadFileName='ReceiveEntry-list'
                    id="TransactionId"
                >
                </NextUITable>
            </MainContainer>
        </div>
    )
}

export default ImportExportEntryMaster